

import { CLIENTTAB, } from 'Constants';
import React, { useState } from 'react'
import { useParams} from 'react-router-dom';
import Template from 'Components/Templates/Template';
import AdminCompleteCaseDetails from './AdminCompleteCaseDetails';
import Header from 'Components/Header/Header';

function AdminCasePage() {

    const {id} = useParams();
    const [activeTab, setActiveTab] = useState(0);
    return (
        <>
        <Header />  
        <Template
        content = {<AdminCompleteCaseDetails id={id} key={id}/>}
        activeTab = {activeTab}
        setActiveTab = {setActiveTab}
        tabs= {CLIENTTAB}
        leaveLeftPanel={true}
        leaveTabs={true}
        />
        </>
    )
}

export default AdminCasePage;